<h1>{{ dialogParams.title }}</h1>
<div class="di-text" [innerHTML]="dialogParams.message"></div>
<div *ngIf="dialogParams.hint && dialogParams.hint !== 'OK'" class="di-hint">
    <span class="di-hint-icon">&#9432;</span>
    {{ dialogParams.hint }}
</div>
<div class="pt-24 di-footer">
    <button id="button-message-dialogue-confirm" nz-button nzType="primary" (click)="modal.destroy()">
        {{ dialogParams.confirmText }}
    </button>
</div>
